<template>
  <div>
    <v-app-bar app fixed>
      <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
      <v-spacer></v-spacer>

      <v-menu
        offset-y
        origin="center center"
        :nudge-bottom="10"
        transition="scale-transition"
      >
        <template v-slot:activator="{ on }">
          <v-btn icon large text v-on="on" :ripple="false">
            <v-avatar size="42px">
              <v-icon dark>mdi-account-circle</v-icon>
            </v-avatar>
          </v-btn>
        </template>
        <v-list>
          <v-list-item :to="{ name: 'Perfil Empresas' }">
            <v-list-item-action>
              <v-icon>mdi-account-tie</v-icon>
            </v-list-item-action>
            <v-list-item-title>Ver Perfil</v-list-item-title>
          </v-list-item>
          <v-list-item @click="logout">
            <v-list-item-action>
              <v-icon>mdi-power-standby</v-icon>
            </v-list-item-action>
            <v-list-item-title>Cerrar Sesión</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <home-drawer v-model="menuVisible" :items="listMenu" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "HomeAppBar",

  components: {
    HomeDrawer: () => import("./Drawer")
  },

  data: function () {
    return {
      menuVisible: false,
      toolbarItem: 0,
      drawer: false,
      listMenu: [
        {
          name: "Inicio",
          icon: "mdi-view-dashboard",
          routerName: "Inicio Empresas"
        },
        {
          name: "Crear Propuesta",
          icon: "mdi-note-plus-outline",
          routerName: "Crear Propuesta Empresas"
        }
      ]
    };
  },

  computed: {
    getBarTitle() {
      let title = this.listMenu.find((i) => i.to === this.$route.path);

      return !!!title
        ? this.$route.name
          ? this.$route.name
          : "App"
        : title.name;
    },

    getStaticProfile() {
      return require("@/assets/anonymous.png");
    },

    ...mapGetters("user", ["getUserInfo", "getError", "fetching"])
  },

  methods: {
    ...mapActions("auth", ["logout"])
  }
};
</script>
